import * as React from "react";
import { getParam } from "../getParam";
import { MyCard } from "../MyCard";
import { useConfig } from "../useConfig";
import { Inputs } from "./Inputs";
import { useTransaction } from "./useTransaction";
import { TransactionDetails } from "./TransactionDetails";
import { Outputs } from "./Outputs";

export function Transaction() {
  const id = "" + getParam("id");
  const transaction = useTransaction(id);
  const config = useConfig();

  if (!transaction) {
    return (
      <div className="page">
        <p className="muted">Loading transaction…</p>
      </div>
    );
  }

  return (
    <div className="page stack">
      <div className="kicker">Transaction</div>
      <h1 className="mono" style={{ fontSize: 16, margin: 0, wordBreak: "break-all" }}>
        {id}
      </h1>
      <TransactionDetails config={config} transaction={transaction} />
      <MyCard header="Inputs" body={<Inputs transaction={transaction} />} />
      <MyCard header="Outputs" body={<Outputs transaction={transaction} />} />
      <details className="card">
        <summary className="card-h">Raw JSON</summary>
        <div className="card-b">
          <pre className="raw">{JSON.stringify(transaction, null, 2)}</pre>
        </div>
      </details>
    </div>
  );
}
